import { render, staticRenderFns } from "./ConsultaObras.vue?vue&type=template&id=1ba7b406"
import script from "./ConsultaObras.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConsultaObras.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports